import React, { useState } from 'react'

import CarouselApp from './CarouselApp'
import Modal from './Modal';

import screenshot from '../assets/IMG_4416.png'
import screenshot2 from '../assets/IMG_4415.png'



export default function AppDetail2() {

    const screenshots = [screenshot, screenshot2]

    const [modalOpen, setModalOpen] = useState(false);

    return (
        <div id="app-detail-2" className="flex flex-col">
            <div className='flex flex-col md:flex-row-reverse py-2'>
                <div className='flex flex-col md:max-w-[50%] gap-3 justify-center'>
                    <p className=''>Aplikace původně vznikla jako bakalářské práce. Zabralo několik měsíců, než spatřila světlo světa a stala se <strong>jednoduchým pomocníkem</strong> pro všechny, kteří se zajímají o své stravování.</p>
                    <p><strong>Jídelák</strong> chce svým uživatelům usnadnit plánování svého jídelníčku. Objevujte nové recepty a přidávejte si je do svého týdenního plánu <strong>na pár kliknutí</strong>.</p>
                    <p>Během několika minut tak budete mít plán na celý týden. Navíc si můžete hlídat kalorie a dosáhnout lépe své vysněné hmotnosti.</p>
                </div>
                <div className='flex mt-5 md:mt-0 sm:max-w-[50%] mx-auto h-96'>
                    <CarouselApp screenshots={screenshots} setModalOpen={setModalOpen} />
                </div>
            </div>

            {modalOpen &&
                <Modal
                    screenshots={screenshots}
                    modalOpen={modalOpen}
                    setModalOpen={setModalOpen}
                />}

        </div>
    )
}
